class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
// --- 开始：滑动屏幕自动关闭购物车弹窗 ---
document.addEventListener('DOMContentLoaded', function() {
  // 1. 获取购物车弹窗元素 (使用您找到的精确 ID)
  const cartNotification = document.getElementById('cart-notification');

  // 如果找不到弹窗元素，就不执行后续代码
  if (!cartNotification) return;

  let isScrolling;

  // 2. 监听页面的滚动事件
  window.addEventListener('scroll', function() {
    // 检查弹窗是否处于显示状态
    // 您的代码显示，当弹窗激活时，会添加 'active' 这个类名
    // 并且我们可以辅助检查它的 display 属性不是 'none'
    const isOpen = cartNotification.classList.contains('active') && 
                   window.getComputedStyle(cartNotification).display !== 'none';

    if (isOpen) {
      // 清除之前的定时器，防止频繁触发
      window.clearTimeout(isScrolling);

      // 设置一个新的定时器，在滚动停止 100 毫秒后执行关闭操作
      isScrolling = setTimeout(function() {
        // 3. 触发关闭动作
        // 使用您找到的精确类名来定位关闭按钮
        const closeButton = cartNotification.querySelector('.cart-notification__close');
        
        if (closeButton) {
          // 模拟点击关闭按钮
          closeButton.click();
          // console.log('页面滚动，购物车弹窗已自动关闭'); // 用于调试
        }
      }, 100); // 延迟 100 毫秒执行，体验更平滑
    }
  }, false);
});
// --- 结束：滑动屏幕自动关闭购物车弹窗 ---
